import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Layout from '../../../layout/default';

const PrivacyPolicy = () => {
    return (
        <Layout title="Privacy Policy">
            <Container className="my-5">
                <Row className="justify-content-center">
                    <Col md={10} lg={8}>
                        <Card className="shadow-lg border-0">
                            <Card.Body className="p-4">
                                <Card.Title className="text-center mb-4 display-6">Grocenetmart Privacy Policy</Card.Title>
                                <Card.Text className="text-justify">
                                    <p className="mb-4 text-muted">
                                        At Grocenetmart, we respect your right to privacy and are committed to protecting the personal information you share with us.
                                    </p>
                                    <h5 className="mb-3">What Information Do We Collect?</h5>
                                    <p className="mb-4 text-muted">
                                        We collect personal information from you when you:
                                    </p>
                                    <ul className="mb-4 text-muted">
                                        <li>Register on our platform</li>
                                        <li>Use our services</li>
                                        <li>Contact us with inquiries or feedback</li>
                                    </ul>
                                    <p className="mb-4 text-muted">
                                        This information may include:
                                    </p>
                                    <ul className="mb-4 text-muted">
                                        <li>Your name and contact details</li>
                                        <li>Your business information (if applicable)</li>
                                        <li>Your usage patterns and preferences</li>
                                    </ul>
                                    <h5 className="mb-3">How Do We Use Your Information?</h5>
                                    <p className="mb-4 text-muted">
                                        We use your personal information to:
                                    </p>
                                    <ul className="mb-4 text-muted">
                                        <li>Provide and improve our services</li>
                                        <li>Communicate with you about our services and promotions</li>
                                        <li>Enhance your user experience</li>
                                        <li>Comply with applicable laws and regulations</li>
                                    </ul>
                                    <h5 className="mb-3">How Do We Protect Your Information?</h5>
                                    <p className="mb-4 text-muted">
                                        We take reasonable measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction.
                                    </p>
                                    <h5 className="mb-3">Sharing Your Information</h5>
                                    <p className="mb-4 text-muted">
                                        We may share your personal information with:
                                    </p>
                                    <ul className="mb-4 text-muted">
                                        <li>Our affiliates and partners</li>
                                        <li>Service providers who assist us with our operations</li>
                                        <li>Law enforcement agencies or regulatory authorities (as required by law)</li>
                                    </ul>
                                    <h5 className="mb-3">Your Rights</h5>
                                    <p className="mb-4 text-muted">
                                        You have the right to:
                                    </p>
                                    <ul className="mb-4 text-muted">
                                        <li>Access and correct your personal information</li>
                                        <li>Opt-out of receiving promotional communications from us</li>
                                        <li>Request deletion of your personal information (subject to applicable laws and regulations)</li>
                                    </ul>
                                    <h5 className="mb-3">Changes to This Policy</h5>
                                    <p className="mb-4 text-muted">
                                        We may update this Privacy Policy from time to time. We will notify you of any significant changes and provide you with a copy of the updated policy.
                                    </p>
                                    <h5 className="mb-3">Contact Us</h5>
                                    <p className="text-muted">
                                        If you have any questions or concerns about our Privacy Policy, please contact us at <a href="mailto:sspepvtltd10@gmail.com" className="text-decoration-none">sspepvtltd10@gmail.com</a>.
                                    </p>
                                    <p className="text-muted">
                                        By using our services, you consent to the collection, use, and disclosure of your personal information as described in this Privacy Policy.
                                    </p>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Layout>
    );
};

export default PrivacyPolicy;
